import "./Boxes.css";
import {useCms} from "../../../context/CmsContext";
import {LandingPageHelper} from "../../Utilities/CmsHelpers";

function Boxes(){
    const {landingData} = useCms();
    const boxes = LandingPageHelper.getBoxesSection(landingData);

    if(!boxes || !boxes.boxes || boxes.boxes.length === 0){
        return (<></>)
    }

    return (<>
        <div id="boxes-section">
            <div className={"boxes-container"}>
                <span className={"boxes-header"}>{boxes?.sectionHeader}</span>
                <div className={"boxes-wrapper"}>
                    {boxes?.boxes?.map((box, index)=>{
                        return (
                            <div className={"box"} key={index}>
                                <div className={"content"}>
                                    <span className={"title"}>
                                        {box?.boxTitle}
                                    </span>
                                    <span className={"description"}>
                                        {box?.boxDescription}
                                    </span>
                                </div>
                                <div className={"icon-wrapper"}>
                                    <img src={box?.boxIcon.data.attributes.url} alt={"box icon"} loading="lazy" decoding="async" />
                                </div>
                            </div>)
                    })}
                </div>
            </div>
        </div>
    </>)
}

export default Boxes;